import React, { PropTypes, Component } from 'react'

class User extends Component {
  componentDidMount () {
    const { userId } = this.props
    this.fetchUser(userId)
  }

  componentDidUpdate (prevProps) {
    const { userId } = this.props

    const shouldFetchUser = prevProps.userId !== userId
    if (shouldFetchUser) {
      this.fetchUser(userId)
    }
  }

  fetchUser (id) {
    this.props.fetchUser(id)
  }

  render () {
    const { user, children } = this.props
    return (user && children) || <div />
  }
}

User.displayName = 'User'
User.propTypes = {
  userId: PropTypes.number.isRequired,
  user: PropTypes.object,
  fetchUser: PropTypes.func.isRequired
}

export default User



// WEBPACK FOOTER //
// ./src/screens/App/screens/User/User.js